module.exports = {"610482001":"城关街道","610482101":"北极镇","610482102":"新民镇","610482103":"龙高镇","610482105":"永乐镇","610482106":"义门镇","610482107":"水口镇","610482108":"韩家镇","610482109":"太峪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610482.json
// module id = 2820
// module chunks = 0